__turbopack_context__.v({
  "mobileWidth": "CopyNotification-module-scss-module__aOUBDa__mobileWidth",
  "toastContainer": "CopyNotification-module-scss-module__aOUBDa__toastContainer",
});
